import wrapRoutes from "./routesWrapper";

const paths = [
  // Home
  { name: "home", path: "/home" },

  // Verification
  { name: "verificationEmail", path: "/verification/email" },
  { name: "verificationPhone", path: "/verification/phone" },
  { name: "verificationOTP", path: "/verification/otp" },

  // New Verification
  { name: "verificationBusinessType", path: "/verification/business-type" },
  { name: "verificationPersonalData", path: "/verification/personal-data" },
  { name: "verificationBusinessDetails", path: "/verification/business-details" },
  { name: "verificationDocuments", path: "/verification/documents" },
  { name: "verificationResubmission", path: "/verification/resubmission" },

  // Transaction
  { name: "transaction", path: "/transaction", exact: true },
  { name: "transactionUploadBeneficiaryCsv", path: "/transaction/upload-beneficiary-csv" },
  { name: "transactionUploadSuperCsv", path: "/transaction/upload-super-csv" },
  { name: "transactionMultiInput", path: "/transaction/multi-input" },
  { name: "transactionBeneficiaryList", path: "/transaction/beneficiary" },
  { name: "transactionMultiBeneficiary", path: "/transaction/multi-beneficiary" },
  { name: "transactionReviewCsv", path: "/transaction/review-csv" },
  { name: "transactionSummaryCsv", path: "/transaction/summary-csv" },
  { name: "transactionTransferDeposit", path: "/transaction/transfer-deposit" },
  { name: "transactionTransferReceiptCsv", path: "/transaction/transfer-receipt/:id" },
  { name: "transactionProcessMaker", path: "/transaction/process-maker/:id" },

  // International Transaction
  { name: "internationalTransaction", path: "/international-transaction", exact: true },
  { name: "internationalTransactionUploadExcel", path: "/international-transaction/upload-excel" },
  { name: "internationalTransactionMultiInput", path: "/international-transaction/multi-input" },
  { name: "internationalTransactionReview", path: "/international-transaction/review" },
  { name: "internationalTransactionSummary", path: "/international-transaction/summary" },
  { name: "internationalDepositPayment", path: "/international-transaction/deposit-payment" },
  { name: "internationalUpdateRFI", path: "/international-transaction/update-rfi" },
  { name: "internationalTransferReceiptCsv", path: "/international-transaction/transfer-receipt/:id" },
  // "Persetujuan Transaksi" (.plans/feature_maker-approver-itr_plan.md). `internationalTransactionApprovalPayment`
  // was added ahead of this layer, in Layer 7, because that layer had a real, load-bearing need for
  // it (the index/detail pages' `Bayar Transaksi` and the approve-modal's `Setujui dan Lanjut Bayar`
  // all push there) -- adding just that one entry early avoided repeating the Layer 3 forward-
  // reference breakage. The other two land here, together with the router binding, RBAC and menu
  // entry (Layer 8) -- canonical detail route per the plan's decision block: review is LOCAL
  // component state on the detail page, not a separate URL, so there is no `/approval/:id` route.
  { name: "internationalTransactionApproval", path: "/international-transaction/approval", exact: true },
  {
    name: "internationalTransactionApprovalReview",
    path: "/international-transaction/approval/review/:id",
    exact: true
  },
  { name: "internationalTransactionApprovalPayment", path: "/international-transaction/approval/payment/:id" },

  // Accept Payment
  { name: "acceptPayment", path: "/accept-payment", exact: true },
  { name: "acceptPaymentHistory", path: "/accept-payment/history" },
  { name: "acceptPaymentRefundHistory", path: "/accept-payment/refund-history" },
  { name: "acceptPaymentReport", path: "/accept-payment/report" },
  { name: "acceptPaymentConfiguration", path: "/accept-payment/configuration" },
  { name: "acceptPaymentFlipCheckoutPage", path: "/accept-payment/flip-checkout-page" },
  { name: "acceptPaymentSettlementReport", path: "/accept-payment/settlement-report" },
  { name: "acceptPaymentLinkPreview", path: "/accept-payment/preview" },

  // History
  { name: "historyTransaction", path: "/transaction/history", exact: true },
  { name: "historyMultiTransaction", path: "/transaction/history/bundle", exact: true },
  { name: "historyWaitingApproval", path: "/transaction/history/approval", exact: true },
  { name: "historyTransactionDetail", path: "/transaction/history/detail/:id" },
  { name: "historyTransactionReport", path: "/transaction/report", exact: true },
  { name: "historyTransactionDraftDetail", path: "/transaction/history/approval/:id", exact: true },
  { name: "historyInternationalTransaction", path: "/international-transaction/history", exact: true },
  { name: "historyInternationalTransactionDetail", path: "/international-transaction/history/detail/:id" },
  { name: "historyInternationalTransactionReport", path: "/international-transaction/report", exact: true },

  // Approval
  { name: "approval", path: "/approval", exact: true },
  { name: "approvalReview", path: "/approval/review/:id" },
  { name: "approvalDeposit", path: "/approval/approval-deposit/:id" },
  { name: "approvalReceipt", path: "/approval/approval-receipt/:key" },
  { name: "approvalSummary", path: "/approval/summary/:id" },

  // Refund
  { name: "refund", path: "/refund", exact: true },
  { name: "createRefund", path: "/refund/create" },

  // My Deposit
  { name: "deposit", path: "/deposit", exact: true },
  { name: "depositHistory", path: "/deposit/history", exact: true },
  { name: "depositStatement", path: "/deposit/statement", exact: true },
  { name: "depositTopUp", path: "/deposit/top-up", exact: true },
  { name: "depositTopUpPayment", path: "/deposit/top-up-pay/:id", exact: true },

  // Beneficiary
  { name: "beneficiaryList", path: "/beneficiary", exact: true },
  { name: "beneficiaryUpload", path: "/beneficiary/upload" },
  { name: "beneficiaryReview", path: "/beneficiary/review" },

  // User Management
  { name: "userManagement", path: "/user-management" },

  // Document
  { name: "document", path: "/document", exact: true },

  // Settings
  { name: "settingsProfileAccount", path: "/settings", exact: true },
  { name: "settingsNotification", path: "/settings/notification", exact: true },
  { name: "settingsTransaction", path: "/settings/transaction", exact: true },
  { name: "settingsDeposit", path: "/settings/deposit", exact: true },
  { name: "settingsTFA", path: "/settings/two-factor-auth", exact: true },
  { name: "settingsActivityLog", path: "/settings/activity-log", exact: true },

  // Developer Menu
  { name: "settingsApiSetting", path: "/developer/api-setting", exact: true },
  { name: "settingsTwoFactorAuth", path: "/developer/two-factor-auth", exact: true },
  { name: "settingsCredentials", path: "/developer/credentials", exact: true },

  // Sandbox - Overview
  { name: "sandboxOverview", path: "/sandbox/overview" },

  // Sandbox - Accept Payment
  { name: "sandboxAccountInquiryHistory", path: "/sandbox/account-inquiry-history" },
  { name: "sandboxAcceptPaymentOverview", path: "/sandbox/accept-payment" },
  { name: "sandboxAcceptPaymentHistory", path: "/sandbox/accept-payment-history" },

  // Sandbox - Transactions
  { name: "sandboxTransaction", path: "/sandbox/transaction", exact: true },
  { name: "sandboxTransactionMultiInput", path: "/sandbox/transaction/multi-input", exact: true },
  { name: "sandboxTransactionSummaryTransaction", path: "/sandbox/transaction/summary", exact: true },
  { name: "sandboxTransactionDepositPayment", path: "/sandbox/transaction/deposit-payment", exact: true },
  { name: "sandboxTransactionTransferPayment", path: "/sandbox/transaction/transfer-payment", exact: true },
  { name: "sandboxInternationalTransactionHistory", path: "/sandbox/international-transaction-history" },
  { name: "sandboxTransactionHistory", path: "/sandbox/transaction-history", exact: true },
  { name: "sandboxTransactionHistoryDetail", path: "/sandbox/transaction-history/detail/:id", exact: true },

  // Sandbox - Settings
  { name: "sandboxApiSettings", path: "/sandbox/api-setting" },
  { name: "sandboxSnapCredentials", path: "/sandbox/credentials" },

  // Sandbox - Verification
  { name: "sandboxVerificationHistory", path: "/sandbox/verification-history" }
];

export default wrapRoutes(paths);
